module.exports = __webpack_public_path__ + "img/fox.4c43be10.png";